export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">欢迎投稿、爆料或商务合作</p>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* 投稿爆料 */}
            <div className="bg-background-50 rounded-2xl p-6 text-center hover:bg-background-200/30 transition-colors cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-send-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">投稿爆料</h3>
              <p className="text-sm text-foreground-600 mb-3">如果你有独家猛料或第一手消息</p>
              <span className="text-sm font-medium text-primary-600">tips@51chigua.com</span>
            </div>

            {/* 商务合作 */}
            <div className="bg-background-50 rounded-2xl p-6 text-center hover:bg-background-200/30 transition-colors cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-briefcase-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-600 mb-3">广告投放、品牌推广与异业合作</p>
              <span className="text-sm font-medium text-accent-600">biz@51chigua.com</span>
            </div>

            {/* 用户反馈 */}
            <div className="bg-background-50 rounded-2xl p-6 text-center hover:bg-background-200/30 transition-colors cursor-pointer">
              <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-smile-2-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">用户反馈</h3>
              <p className="text-sm text-foreground-600 mb-3">意见、建议或问题反馈通道</p>
              <span className="text-sm font-medium text-secondary-600">feedback@51chigua.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}